import React from "react";
import { inject, observer } from "mobx-react";
import Snackbar from '@mui/material/Snackbar';
import { UserStore } from "../stores/UserStore";
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import SettingsIcon from '@mui/icons-material/Settings';
import IconButton from '@mui/material/IconButton';

interface ISiAppAdminSnackbarProps {
    userStore?: UserStore;
}

interface ISiAppAdminSnackbarState {
}

export const SiAppAdminSnackbar = inject("userStore")(observer(class AppAdminSnackbar extends React.Component<ISiAppAdminSnackbarProps, ISiAppAdminSnackbarState> {

    constructor(props) {
        super(props)

        this.state = {
            loadingDistricts: false,
            loadingSchools: false,
            mounted: false
        }

        if (!props.userStore) {
            throw new Error("User store is not defined")
        }
    }

    render() {

        const { userStore } = this.props

        return (
            <Snackbar
                open={userStore?.hasActiveOverride}
            >
              <Alert
                severity="info"
                action={
                    <IconButton
                    onClick={userStore?.openAdminModal}
                    disabled={userStore?.adminModalOpen}
                    >
                        <SettingsIcon/>
                    </IconButton>
                }
              >
                <AlertTitle>Admin Overrides</AlertTitle>
                {userStore?.organizationOverrideMessage}
                </Alert>
            </Snackbar>
        )
    }
}))